import { useCallback } from "react";
import { Badge, ColorSwatch, Group, Pill, Text } from "@mantine/core";
import { CommunicationBypassPrefix } from "../../../services/admin/communicationSettings.service";

interface SelectedBypassPrefixPillProps {
  prefix: CommunicationBypassPrefix;
  onRemove: (prefixId: string) => void;
}

export default function SelectedBypassPrefixPill({
  prefix,
  onRemove,
}: SelectedBypassPrefixPillProps) {
  const handleRemove = useCallback(() => {
    onRemove(prefix.id);
  }, [onRemove, prefix.id]);

  return (
    <Pill
      size="lg"
      withRemoveButton
      onRemove={handleRemove}
      aria-label={`Selected prefix ${prefix.code}`}
      removeButtonProps={{
        "aria-label": `Remove selected prefix ${prefix.code}`,
      }}
    >
      <Group gap={6} wrap="nowrap">
        <ColorSwatch
          color={prefix.color || "var(--mantine-color-gray-5)"}
          size={14}
        />
        <Text component="span" ff="monospace" fw={700} size="xs">
          {prefix.code}
        </Text>
        {!prefix.isActive && (
          <Badge color="gray" variant="light" size="xs">
            Inactive
          </Badge>
        )}
      </Group>
    </Pill>
  );
}
